import { type SxProps } from '@mui/material';

export const ModalHeaderCloseIconStyles: SxProps = {
  cursor: 'pointer',
  height: '20px',
  width: '20px',
};
